import {rrcEp10WasteManifestsSelector, useGetRrcEp10WasteManifestsByKeyQuery} from "@ots-frontend/ots-data";
import {Grid, GridProps} from "@mantine/core";
import {useMemo} from "react";
import {
  RrcEp10WasteManifestDataTable
} from "../../data-table/RrcEp10WasteManifestDataTable/RrcEp10WasteManifestDataTable";

export type RrcEp10WasteManifestVersionsProps = Omit<GridProps, 'children'> & {
  manifestNumber: string
  tenantCode?: string
}

export const RrcEp10WasteManifestVersions = (props: RrcEp10WasteManifestVersionsProps) => {
  const {manifestNumber, tenantCode, ...rest} = props;

  const selectRrcEp10WasteManifests = useMemo(() => {
    return rrcEp10WasteManifestsSelector();
  }, []);

  const {rrcEp10WasteManifests, isLoading, isFetching} = useGetRrcEp10WasteManifestsByKeyQuery({
    manifestNumber: manifestNumber,
    tenantCode: tenantCode,
  }, {
    selectFromResult: (result) => ({
      rrcEp10WasteManifests: selectRrcEp10WasteManifests(result),
      isLoading: result.isLoading,
      isFetching: result.isFetching,
    })
  });

  return (
    <Grid {...rest}>
      <Grid.Col span={12}>
        <RrcEp10WasteManifestDataTable
          withBorder
          records={rrcEp10WasteManifests}
          fetching={isLoading || isFetching}
          viewNav="by_id"
        />
      </Grid.Col>
    </Grid>
  )
};
